import React, { JSX, MouseEventHandler } from 'react';
import PaginationControls from '../shared/SearchPaginationControls';
import LocationResult from './LocationResult';
import { LatLng, LocationFields } from 'components/types/MapTypes';

type LocationsSearchResultsProps = {
  apiError: boolean;
  loading: boolean;
  clearAllFilters: MouseEventHandler<HTMLButtonElement>;
  count: number;
  origin: LatLng;
  page: number;
  results: Array<LocationFields>;
  pageSize: number;
  searchType: string;
  updatePage: (page: number) => void;
  viewMode: string;
};

const LocationsSearchResults = (
  props: LocationsSearchResultsProps
): JSX.Element => {
  const {
    apiError,
    loading,
    clearAllFilters,
    count,
    origin,
    page,
    results,
    pageSize,
    updatePage,
    viewMode,
  } = props;

  return (
    <>
      <div className={'results-list-container ' + (loading ? 'loading' : '')}>
        {!loading && results?.length == 0 ? (
          <div className="no-results-message">
            {apiError ? (
              <>
                <h2>
                  Something&rsquo;s not quite right. Let&rsquo;s help you find
                  what you&rsquo;re looking for.
                </h2>
                <p className="heading-2">You can try:</p>
                <ul>
                  <li>
                    <button className="osf-link" onClick={clearAllFilters}>
                      Resetting your filters
                    </button>
                  </li>
                  <li>
                    <a href={location.href}>Refreshing the page</a>
                  </li>
                  <li>
                    <a href="https://www.osfhealthcare.org">
                      Returning to the OSF HealthCare homepage
                    </a>
                  </li>
                </ul>
              </>
            ) : (
              <>
                <h2>{"We can't find any matching locations."}</h2>
                <p>Here are a few tips that might help:</p>
                <ul>
                  <li>Check your spelling.</li>
                  <li>
                    Be less specific - try removing a single criteria or
                    choosing a slightly different one.
                  </li>
                  <li>
                    If specifying a location, increase the acceptable distance
                    from your location.
                  </li>
                  <li>
                    Want to start over?{' '}
                    <button className="osf-link" onClick={clearAllFilters}>
                      Reset your filters.
                    </button>
                  </li>
                </ul>
              </>
            )}
          </div>
        ) : (
          <>
            <ul className={`results-list view-mode-${viewMode}`}>
              {results &&
                results.map((result: LocationFields, i: number) => {
                  return (
                    <li
                      className={`results-list-item ${i != 0 && (i + 1) % 10 == 0 && 'tenth-item'}`}
                      key={result.locationid}
                    >
                      <LocationResult
                        keyProp={result.locationid}
                        location={result}
                        origin={origin}
                        viewMode={viewMode}
                      />
                    </li>
                  );
                })}
            </ul>
            <PaginationControls
              count={count}
              pageSize={pageSize}
              page={page}
              updatePage={updatePage}
            />
          </>
        )}
      </div>
    </>
  );
};
export default LocationsSearchResults;
